<template>
  <span v-if="skipZeroCoins && coins === '00'">
    {{prefix}}{{wholeValue}}
  </span>
  <span v-else-if="isHtml">
    {{prefix}}{{wholeValue}}.<span class="coins">{{coins}}</span>
  </span>
  <span v-else>
    {{prefix}}{{wholeValue}}.{{coins}}
  </span>
</template>

<script>
  export default {
    name: 'ToCoins',
    props: {
      value: Number,
      isHtml: {
        type: Boolean,
        'default': true,
      },
      prefix: {
        type: String,
        'default': '$',
      },
      skipZeroCoins: {
        type: Boolean,
        'default': false,
      },
    },
    computed: {
      wholeValue: function() {
        return parseInt(this.value / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      coins: function() {
        return (this.value - parseInt(this.value / 100) * 100).toString().padStart(2, '0');
      },
    },
  };
</script>